import { Text } from 'src/Components'
import Format from 'src/Components/shared/Format'
import { CarouselListing } from 'src/types/listings'
import { defineMessages, useIntl } from 'react-intl'
import { useViewListingShowPageUrl } from 'src/hooks/listings'
import { PocketAmountAndMortgageDiff } from './PocketAmountAndMortgageDiff'
import ExternalListingsButton from 'src/Components/buyers/Button/ExternalListingsButton'

import baseStyles from '../ListingsCarousel.module.scss'
import styles from './ListingsCarouselSlide.module.scss'

export const MSG = defineMessages({
  bed: {
    id: 'MarketSpotLight.equitySmartSearch.bed',
    defaultMessage: '{bed} bed',
  },
  bath: {
    id: 'MarketSpotLight.equitySmartSearch.bath',
    defaultMessage: '{bath} bath',
  },
  sqft: {
    id: 'MarketSpotLight.equitySmartSearch.sqft',
    defaultMessage: '{sqft} sqft',
  },
})

export interface ListingsCarouselSlideProps {
  listing: CarouselListing
}

export const ListingsCarouselSlide = ({
  listing,
}: ListingsCarouselSlideProps) => {
  const intl = useIntl()
  const listingUrl = useViewListingShowPageUrl(listing)

  return (
    <ExternalListingsButton
      key={listing.id}
      listingsUrl={listingUrl}
      className={baseStyles.buttonParent}
    >
      <div
        className={styles.listingImageContainer}
        style={{ backgroundImage: `url(${listing.mainPhoto})` }}
      />
      <div className={styles.listingDataContainer}>
        <div className={styles.listingPriceTextRow}>
          <Text
            size='xl'
            weight='bold'
            variantCount='900'
            variant='neutralCool'
          >
            {listing.formattedPrice}
          </Text>
        </div>
        <div>
          <div className={styles.bedBathSqftTextRow}>
            <Text
              variantCount='700'
              variant='neutralCool'
              className={styles.bedBathSqft}
            >
              {intl.formatMessage(MSG.bed, { bed: listing.bedrooms })}
            </Text>
            <Text
              variantCount='700'
              variant='neutralCool'
              className={styles.bedBathSqft}
            >
              {intl.formatMessage(MSG.bath, { bath: listing.bathrooms })}
            </Text>
            <Text
              variantCount='700'
              variant='neutralCool'
              className={styles.bedBathSqft}
            >
              {intl.formatMessage(MSG.sqft, {
                sqft: Format.number(listing.livingAreaSqFt),
              })}
            </Text>
          </div>
          {listing.pocketAmount && listing.mortgagePaymentDifference && (
            <PocketAmountAndMortgageDiff
              pocketAmount={listing.pocketAmount}
              mortgagePaymentDifference={listing.mortgagePaymentDifference}
            />
          )}
        </div>
      </div>
    </ExternalListingsButton>
  )
}
